export const dataHelpers = {
  data() {
    return {
    }
  },
  methods: {
    deepMerge(obj1, obj2) {
      const merged = {
        ...obj1,
        ...obj2
      };
    
      for (const key of Object.keys(merged)) {
        if (typeof merged[key] === 'object' && merged[key] !== null) {
          merged[key] = this.deepMerge(obj1[key], obj2[key]);
        }
      }
    
      return merged;
    },
    deepMergeSafeFirst(obj1, obj2) {
      const merged = Object.assign(obj2, obj1);
    
      for (const key of Object.keys(merged)) {
        if (typeof merged[key] === 'object' && merged[key] !== null && obj1[key] && obj2[key]) {
          merged[key] = this.deepMergeSafeFirst(obj1[key], obj2[key]);
        }
      }
    
      return merged;
    },
    queryStringToObject(queryString) {
      let queryObject = {};
      let pairs = queryString.slice(1).split('&');
      
      pairs.forEach(pair => {
        let [key, value] = pair.split('=');
        queryObject[key] = decodeURIComponent(value);
      });
  
      return queryObject;
    },
    objectToQueryString(obj) {
      let str = [];
      for(let p in obj){
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
      }
      return str.join("&");
   },
   cleanHTML(html) {
      // Remove Vue's scoped CSS attributes
      html = html.replace(/ data-v-[a-z0-9]+=""/g, '').trim();
    
      // Remove multiple spaces
      html = html.replace(/\s\s+/g, ' ');
    
      // Remove empty <p> tags or tags that only contain spaces or line breaks
      html = html.replace(/<p>(\s|&nbsp;)*<\/p>/g, '');
    
      // Remove excessive line breaks and extra spaces between tags
      html = html.replace(/>\s+</g, '><');
    
      // Fix blockquote elements that might have become malformed
      html = html.replace(/<blockquote([^>]*)>([\s\S]*?)<\/blockquote>/g, (match, attrs, content) => {
        // Clean content inside blockquote but keep structure
        const cleanedContent = content.trim().replace(/(<\/?(?!\/?blockquote\b)[^>]+>)/g, (tag) => {
          return tag.trim();
        });
        return `<blockquote${attrs}>${cleanedContent}</blockquote>`;
      });
    
      return html;
    }  
  }
}